import {
  DownloadOutlined,
  EditOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { Button, Col, Flex, Form, Input, Popover, Row, Upload } from "antd";
import Title from "antd/es/typography/Title";
import { useState } from "react";
import NotificationApi from "../../../apis/NotificationApi";
import {
  getFormartFile,
  isNullOrEmpty,
  showNotification,
} from "../../../common";
import FiledNameFromLockCer from "../../../common/FiledNameFromLockCer";
import TypeFromLockCer from "../../../common/TypeFromLockCer";
import ModalViewFile from "./ModalViewFile";
import "./index.css";
import ModalConfirmSign from "../../lockcertificate/ModalConfirmSign";
import LockCertificateApi from "../../../apis/LockCertificateApi";
import constants from "../../../constants";

const ProfileMissing = (props) => {
  const {
    isFinish,
    // visbleFiles,
    setFileAdditionals,
    fileAdditionals,
    setLoading,
    form,
  } = props;
  console.log("fileAdditionals: ", fileAdditionals);

  const [isModalViewFileOpen, setIsModalViewFileOpen] = useState(false);
  const [isModalConfirmSignOpen, setIsModalConfirmSignOpen] = useState(false);
  const [base64File, setBase64File] = useState(null);
  const [formatFile, setFormatFile] = useState(null);
  const [linkDk02Sign, setLinkDk02Sign] = useState("");

  const validateFileUploaded = (_, value) => {
    // Hàm kiểm tra tùy chỉnh để kiểm tra xem file đã được tải lên hay chưa
    return value && value.length > 0 && value[0].status !== "error"
      ? Promise.resolve()
      : Promise.reject("Vui lòng tải lên file đính kèm!");
  };

  const onBeforeUpload = (file, filed, visbleFile) => {
    const allowedFileTypes = ["image/png", "image/jpeg", "application/pdf"];
    if (!allowedFileTypes.includes(file.type)) {
      showNotification("error", "Vui lòng chọn file ảnh hoặc pdf");
      return false;
    }
    if (file.size > constants.MAX_SIZE_UPLOAD_FILE) {
      showNotification(
        "error",
        "Tệp quá lớn. Kích thước tối đa cho phép là 5MB"
      );
      return false;
    }

    let reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = function () {
      setFileAdditionals((prevFileAdditionals) => {
        // // Nếu mảng fileAdditionals rỗng, thêm đối tượng mới
        // if (prevFileAdditionals.length === 0) {
        //   return [
        //     {
        //       files: {
        //         [filed]: {
        //           fileName: file.name,
        //           type: filed,
        //           data: reader.result.split(",")[1],
        //         },
        //       },
        //     },
        //   ];
        // }

        // Nếu mảng không rỗng, cập nhật dữ liệu
        return prevFileAdditionals.map((fileAdditional) => {
          if (
            fileAdditional.certificateSerial === visbleFile.certificateSerial
          ) {
            // Cập nhật fileAdditional tương ứng
            const updatedFiles = {
              ...fileAdditional.files,
              [filed]: {
                ...fileAdditional.files[filed],
                fileName: file.name,
                type: filed,
                data: reader.result.split(",")[1],
              },
            };

            return {
              ...fileAdditional,
              files: updatedFiles,
              certificateSerial: visbleFile.certificateSerial,
              object: visbleFile.object,
              dateCts: visbleFile.dateCts,
              linkDk02: visbleFile.linkDk02,
            }; // Trả về đối tượng đã cập nhật
          }
          console.log("fileAdditional: ", fileAdditional);

          return fileAdditional; // Giữ nguyên các đối tượng khác
        });
      });
    };

    reader.onerror = function (error) {
      console.log("Error: ", error);
    };

    return false;
  };

  const handleViewFile = (filed, fileAdditional) => {
    const formartFile = getFormartFile(fileAdditional[filed].fileName);
    getFile(fileAdditional[filed].fileId, formartFile);
  };

  const getFile = async (fileId, formartFile) => {
    setLoading(true);
    try {
      const res = await NotificationApi.getFile(fileId);
      if (res && res.status === 200 && res.data.data.data) {
        setBase64File(formartFile + ";base64," + res.data.data.data);
        setFormatFile(formartFile);
        setIsModalViewFileOpen(true);
      } else {
        showNotification("error", "Không tìm thấy file", "Thông báo");
      }
    } catch (error) {
      console.log("error: ", error);
      showNotification("error", error.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };
  const handleOpenModalConfirmSign = (linkDk02) => {
    if (isNullOrEmpty(form.getFieldValue("email"))) {
      showNotification("error", "Vui lòng nhập email!", "Thông báo");
      return;
    } else {
      setIsModalConfirmSignOpen(true);
      setLinkDk02Sign(linkDk02);
    }
  };

  const generateDk01 = async (certificateSerial, object) => {
    setLoading(true);
    try {
      const data = {
        certificateSerial: certificateSerial,
        object: object
      }
      const res = await LockCertificateApi.generateDk01(data);
      if (res && res.status === 200 && res.data.data) {
        const byteCharacters = atob(res.data.data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
          type: "application/octet-stream",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "FCA_DK-01_Giấy đăng ký sử dụng dịch vụ.pdf"
        ); // Set your desired file name here
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setLoading(false);
      } else {
        showNotification("error", "Không tìm thấy file", "Thông báo");
      }
    } catch (error) {
      console.log("error: ", error);
      showNotification("error", error.message, "Thông báo");
    } finally {
      setLoading(false);
    }
  };
  const contentHover = (
    <div>
      <p>File gồm cả 2 mặt trước và sau</p>
    </div>
  );
  const viewTextDKDC = (object = 1) => {
    if(Number(object) === 4){
      return <>DC01 đã ký</>
    }
    return <>DK01 đã ký</>
  };
  const viewTextDowloadDKDC = (object) => {
    if(Number(object) === 4){
      return <>Tải mẫu DC01</>
    }
    return <>Tải mẫu DK01</>
  };
  return (
    <>
      {
        <Form.Item
          label={<Title level={5}>Danh sách hồ sơ chưa hợp lệ cần bổ sung</Title>}
        >
          <span className="title-noti-req-file">
            Lưu ý: Hệ thống hỗ trợ file dạng pdf hoặc ảnh với dung lượng dưới
            5MB
          </span>
          {fileAdditionals &&
            fileAdditionals.length > 0 &&
            fileAdditionals.map((fileAdditional, index) =>
              fileAdditional.type === TypeFromLockCer.TO_CHUC ? (
                <>
                  {" "}
                  <Row gutter={24}>
                    <Col span={12}>
                      <span className="txt-certificate-serial">
                        {(Number(index)+ 1)+"."} Chứng thư số:{" "}
                      </span>{" "}
                      <span> {fileAdditional.dateCts}</span>
                    </Col>
                  </Row>
                  <Row gutter={12}>
                    {fileAdditional?.files[FiledNameFromLockCer.TC_GTPL.filed]
                      .view && (
                      <Col span={6}>
                        <Form.Item
                          label={
                            <>
                              {fileAdditional.files[
                                FiledNameFromLockCer.TC_GTPL.filed
                              ]?.fileId ? (
                                <>
                                  Giấy ĐKKD (
                                  <span
                                    onClick={() =>
                                      handleViewFile(
                                        FiledNameFromLockCer.TC_GTPL.filed,
                                        fileAdditional.files
                                      )
                                    }
                                    className="view-file"
                                  >
                                    Xem file
                                  </span>{" "}
                                  )
                                </>
                              ) : (
                                "Giấy ĐKKD"
                              )}
                            </>
                          }
                          name={index + "dkkd"}
                          labelCol={{ span: 12 }}
                          wrapperCol={{ span: 24 }}
                          className="file-input"
                          required={true} // Fix: Use true without quotes
                          rules={[
                            { validator: validateFileUploaded },
                            // Sử dụng custom validator
                          ]}
                        >
                          <Flex>
                            <Input
                              placeholder=""
                              value={
                                fileAdditional.files[
                                  FiledNameFromLockCer.TC_GTPL.filed
                                ]?.fileName
                              }
                              disabled="false"
                            />

                            <Upload
                              beforeUpload={(e) =>
                                onBeforeUpload(
                                  e,
                                  FiledNameFromLockCer.TC_GTPL.filed,
                                  fileAdditional
                                )
                              }
                              listType="text"
                              accept="image/png,image/jpeg,application/pdf"
                              maxCount={1}
                            >
                              <Button
                                className="chosse-file"
                                icon={<UploadOutlined />}
                                disabled={isFinish}
                              >
                                Chọn File
                              </Button>
                            </Upload>
                          </Flex>
                        </Form.Item>
                      </Col>
                    )}

                    {fileAdditional?.files[
                      FiledNameFromLockCer.TC_CMND_NDD.filed
                    ].view && (
                      <Col span={6}>
                        <Form.Item
                          label={
                            <>
                              {fileAdditional.files[
                                FiledNameFromLockCer.TC_CMND_NDD.filed
                              ]?.fileId ? (
                                <>
                                  <div>
                                    <span>CMND/CCCD </span>
                                    <Popover content={contentHover} title="Lưu ý">
                                      (<i>i</i>)
                                    </Popover>
                                  </div>(
                                  <span
                                    onClick={() =>
                                      handleViewFile(
                                        FiledNameFromLockCer.TC_CMND_NDD.filed,
                                        fileAdditional.files
                                      )
                                    }
                                    className="view-file"
                                  >
                                    Xem file
                                  </span>{" "}
                                  )
                                </>
                              ) : (
                                <div>
                                  <span>CMND/CCCD </span>
                                  <Popover content={contentHover} title="Lưu ý">
                                    (<i>i</i>)
                                  </Popover>
                                </div>
                              )}
                            </>
                          }
                          name={index + "cmnd"}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          className="file-input"
                          rules={[
                            { validator: validateFileUploaded }, // Sử dụng custom validator
                          ]}
                          required="true"
                        >
                          <Flex>
                            <Input
                              value={
                                fileAdditional?.files[
                                  FiledNameFromLockCer.TC_CMND_NDD.filed
                                ]?.fileName
                              }
                              disabled="false"
                            />
                            <Upload
                              beforeUpload={(e) =>
                                onBeforeUpload(
                                  e,
                                  FiledNameFromLockCer.TC_CMND_NDD.filed,
                                  fileAdditional
                                )
                              }
                              listType="text"
                              accept="image/png,image/jpeg,application/pdf"
                              maxCount={1}
                            >
                              <Button
                                className="chosse-file"
                                icon={<UploadOutlined />}
                                disabled={isFinish}
                              >
                                Chọn File
                              </Button>
                            </Upload>
                          </Flex>
                        </Form.Item>
                      </Col>
                    )}

                    {fileAdditional?.files[FiledNameFromLockCer.TC_DK0101.filed]
                      .view && (
                      <Col span={6}>
                        <Form.Item
                          label={
                            <>
                              {fileAdditional?.files[
                                FiledNameFromLockCer.TC_DK0101.filed
                              ]?.fileId ? (
                                <>
                                  {viewTextDKDC(fileAdditional.object)} (
                                  <span
                                    onClick={() =>
                                      handleViewFile(
                                        FiledNameFromLockCer.TC_DK0101.filed,
                                        fileAdditional.files
                                      )
                                    }
                                    className="view-file"
                                  >
                                    Xem file
                                  </span>{" "}
                                  )
                                </>
                              ) : (
                                viewTextDKDC(fileAdditional.object)
                              )}{" "}
                              <Button
                                icon={<DownloadOutlined />}
                                className="btn-dow-dk01"
                                onClick={() =>{generateDk01(fileAdditional.certificateSerial, fileAdditional.object)}}
                              >
                                {/* <a
                                href={
                                  "/FCA_DK-01_Giấy đăng ký sử dụng dịch vụ.docx"
                                }
                                download
                              > */}
                                <i className="fas fa-download fa-lg" />
                                {viewTextDowloadDKDC(fileAdditional.object)}
                                {/* </a> */}
                              </Button>
                            </>
                          }
                          name={index + "dk01"}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          className="file-input"
                          required="true"
                          rules={[
                            { validator: validateFileUploaded }, // Sử dụng custom validator
                          ]}
                        >
                          <Flex>
                            <Input
                              value={
                                fileAdditional?.files[
                                  FiledNameFromLockCer.TC_DK0101.filed
                                ]?.fileName
                              }
                              disabled="false"
                            />
                            <Upload
                              beforeUpload={(e) =>
                                onBeforeUpload(
                                  e,
                                  FiledNameFromLockCer.TC_DK0101.filed,
                                  fileAdditional
                                )
                              }
                              listType="text"
                              accept="image/png,image/jpeg,application/pdf"
                              maxCount={1}
                            >
                              <Button
                                className="chosse-file"
                                icon={<UploadOutlined />}
                                disabled={isFinish}
                              >
                                Chọn File
                              </Button>
                            </Upload>
                          </Flex>
                        </Form.Item>
                      </Col>
                    )}

                    <Col span={12} className="btn-dow-sign">
                      {fileAdditional[FiledNameFromLockCer.LINK_DK02.filed] && (
                        <Button
                          icon={<EditOutlined />}
                          className="btn-sign"
                          onClick={() =>
                            handleOpenModalConfirmSign(fileAdditional.linkDk02)
                          }
                        >
                          Ký DK02
                        </Button>
                      )}
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  {" "}
                  <Row gutter={12}>
                    <Col span={12}>
                      <span className="txt-certificate-serial">
                      {(Number(index)+ 1)+"."} Chứng thư số:{" "}
                      </span>{" "}
                      <span> {fileAdditional.dateCts}</span>
                    </Col>
                  </Row>
                  <Row gutter={12}>
                    {fileAdditional?.files[
                      FiledNameFromLockCer.CN_XACNHANTOCHUC.filed
                    ].view && (
                      <Col span={6}>
                        <Form.Item
                          label={
                            <>
                              {fileAdditional?.files[
                                FiledNameFromLockCer.CN_XACNHANTOCHUC.filed
                              ]?.fileId ? (
                                <>
                                  Giấy ĐKKD (
                                  <span
                                    onClick={() =>
                                      handleViewFile(
                                        FiledNameFromLockCer.CN_XACNHANTOCHUC
                                          .filed,
                                        fileAdditional.files
                                      )
                                    }
                                    className="view-file"
                                  >
                                    Xem file
                                  </span>{" "}
                                  )
                                </>
                              ) : (
                                "Giấy ĐKKD"
                              )}
                            </>
                          }
                          name={index + "dkkd"}
                          labelCol={{ span: 12 }}
                          wrapperCol={{ span: 24 }}
                          className="file-input"
                          required="true"
                          rules={[
                            { validator: validateFileUploaded }, // Sử dụng custom validator
                          ]}
                        >
                          <Flex>
                            <Input
                              placeholder=""
                              value={
                                fileAdditional?.files[
                                  FiledNameFromLockCer.CN_XACNHANTOCHUC.filed
                                ]?.fileName
                              }
                              disabled="false"
                            />

                            <Upload
                              beforeUpload={(e) =>
                                onBeforeUpload(
                                  e,
                                  FiledNameFromLockCer.CN_XACNHANTOCHUC.filed,
                                  fileAdditional
                                )
                              }
                              listType="text"
                              accept="image/png,image/jpeg,application/pdf"
                              maxCount={1}
                            >
                              <Button
                                className="chosse-file"
                                icon={<UploadOutlined />}
                                disabled={isFinish}
                              >
                                Chọn File
                              </Button>
                            </Upload>
                          </Flex>
                        </Form.Item>
                      </Col>
                    )}
                    {fileAdditional?.files[FiledNameFromLockCer.CN_CMND.filed]
                      .view && (
                      <Col span={6}>
                        <Form.Item
                          label={
                            <>
                              {fileAdditional?.files[
                                FiledNameFromLockCer.CN_CMND.filed
                              ]?.fileId ? (
                                <>
                                  <div>
                                    <span>CMND/CCCD </span>
                                    <Popover content={contentHover} title="Lưu ý">
                                      (<i>i</i>)
                                    </Popover>
                                  </div> (
                                  <span
                                    onClick={() =>
                                      handleViewFile(
                                        FiledNameFromLockCer.CN_CMND.filed,
                                        fileAdditional.files
                                      )
                                    }
                                    className="view-file"
                                  >
                                    Xem file
                                  </span>{" "}
                                  )
                                </>
                              ) : (
                                <div>
                                  <span>CMND/CCCD </span>
                                  <Popover content={contentHover} title="Lưu ý">
                                    (<i>i</i>)
                                  </Popover>
                                </div>
                              )}
                            </>
                          }
                          name={index + "cmnd"}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          className="file-input"
                          required="true"
                          rules={[
                            { validator: validateFileUploaded }, // Sử dụng custom validator
                          ]}
                        >
                          <Flex>
                            <Input
                              value={
                                fileAdditional?.files[
                                  FiledNameFromLockCer.CN_CMND.filed
                                ]?.fileName
                              }
                              disabled="false"
                            />
                            <Upload
                              beforeUpload={(e) =>
                                onBeforeUpload(
                                  e,
                                  FiledNameFromLockCer.CN_CMND.filed,
                                  fileAdditional
                                )
                              }
                              listType="text"
                              accept="image/png,image/jpeg,application/pdf"
                              maxCount={1}
                            >
                              <Button
                                className="chosse-file"
                                icon={<UploadOutlined />}
                                disabled={isFinish}
                              >
                                Chọn File
                              </Button>
                            </Upload>
                          </Flex>
                        </Form.Item>
                      </Col>
                    )}
                     {fileAdditional?.files[FiledNameFromLockCer.CN_DK0102.filed]
                      .view && (
                      <Col span={6}>
                        <Form.Item
                          label={
                            <>
                              {fileAdditional?.files[
                                FiledNameFromLockCer.CN_DK0102.filed
                              ]?.fileId ? (
                                <>
                                  {viewTextDKDC(fileAdditional.object)} (
                                  <span
                                    onClick={() =>
                                      handleViewFile(
                                        FiledNameFromLockCer.CN_DK0102.filed,
                                        fileAdditional.files
                                      )
                                    }
                                    className="view-file"
                                  >
                                    Xem file
                                  </span>{" "}
                                  )
                                </>
                              ) : (
                                viewTextDKDC(fileAdditional.object)
                              )}{" "}
                              <Button
                                icon={<DownloadOutlined />}
                                className="btn-dow-dk01"
                                onClick={() => {generateDk01(fileAdditional.certificateSerial, fileAdditional.object)}}
                              >
                                {/* <a
                                href={
                                  "/FCA_DK-01_Giấy đăng ký sử dụng dịch vụ.docx"
                                }
                                download
                              > */}
                                <i className="fas fa-download fa-lg" />
                                {viewTextDowloadDKDC(fileAdditional.object)}
                                {/* </a> */}
                              </Button>
                            </>
                          }
                          name={index + "dk01"}
                          labelCol={{ span: 24 }}
                          wrapperCol={{ span: 24 }}
                          className="file-input"
                          required="true"
                          rules={[
                            { validator: validateFileUploaded }, // Sử dụng custom validator
                          ]}
                        >
                          <Flex>
                            <Input
                              value={
                                fileAdditional?.files[
                                  FiledNameFromLockCer.CN_DK0102.filed
                                ]?.fileName
                              }
                              disabled="false"
                            />
                            <Upload
                              beforeUpload={(e) =>
                                onBeforeUpload(
                                  e,
                                  FiledNameFromLockCer.CN_DK0102.filed,
                                  fileAdditional
                                )
                              }
                              listType="text"
                              accept="image/png,image/jpeg,application/pdf"
                              maxCount={1}
                            >
                              <Button
                                className="chosse-file"
                                icon={<UploadOutlined />}
                                disabled={isFinish}
                              >
                                Chọn File
                              </Button>
                            </Upload>
                          </Flex>
                        </Form.Item>
                      </Col>
                    )}

                    <Col span={12} className="btn-dow-sign">
                      {fileAdditional[FiledNameFromLockCer.LINK_DK02.filed] && (
                        <Button
                          icon={<EditOutlined />}
                          className="btn-sign"
                          onClick={() =>
                            handleOpenModalConfirmSign(fileAdditional.linkDk02)
                          }
                        >
                          Ký DK02
                        </Button>
                      )}
                    </Col>
                  </Row>
                </>
              )
            )}
        </Form.Item>
      }
      {isModalViewFileOpen && (
        <ModalViewFile
          base64File={base64File}
          isModalViewFileOpen={isModalViewFileOpen}
          handleCancel={() => setIsModalViewFileOpen(false)}
          formatFile={formatFile}
        />
      )}
      {isModalConfirmSignOpen && (
        <ModalConfirmSign
          isModalConfirmSignOpen={isModalConfirmSignOpen}
          handleCancel={() => setIsModalConfirmSignOpen(false)}
          form={form}
          linkDk02={linkDk02Sign}
        />
      )}
    </>
  );
};
export default ProfileMissing;
